import React, { Component } from 'react';
import { connect } from 'react-redux';

class ChangePassword extends Component {
  constructor (props) {
    super(props);

    this.state = {
      view: 'signin'
    };
  }

  componentWillReceiveProps (newProps) {
    if (this.props.redirect) {
      this.props.history.push(this.props.redirect);
      this.props.clearRedirect();
    }
  }

  handleChange (event) {
    let newState = {};
    newState[event.target.attributes.name.value] = event.target.value;
    this.setState(newState);
  }

  async handleSubmit (event) {
    event.preventDefault();

    const { password, confirmPassword } = this.state;

    if (password && confirmPassword && password === confirmPassword) {
      this.props.changePassword(password);
    }
  }

  render () {
    return (
      <div className='m-grid m-grid--hor m-grid--root m-page'>
        <div
          className='m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--2 m-login-2--skin-2'
          id='m_login'
        >
          <div className='m-grid__item m-grid__item--fluid m-login__wrapper'>
            <div className='m-login__container'>
              <div className='m-login__logo'>
                <img src='assets/media/img/logo/logo.png' alt='Kangarootime' />
              </div>
              <div
                className={
                  'm-login__signup ' +
                  (this.state.isAnimatingsignup ? 'flipInX animated' : '')
                }
              >
                <div className='m-login__head'>
                  <h3 className='m-login__title'>New Password Required</h3>
                  <div className='m-login__desc'>
                    Your password needs to be changed. Enter a new password
                    below.
                  </div>
                  <div className='m-login__desc'>{this.props.errorMessage}</div>
                </div>
                <form
                  className='m-login__form m-form'
                  action=''
                  onSubmit={e => this.handleSubmit(e)}
                >
                  <div className='form-group m-form__group'>
                    <input
                      className='form-control m-input'
                      type='password'
                      placeholder='Password'
                      name='password'
                      onChange={e => this.handleChange(e)}
                    />
                  </div>
                  <div className='form-group m-form__group'>
                    <input
                      className='form-control m-input m-login__form-input--last'
                      type='password'
                      placeholder='Confirm Password'
                      name='confirmPassword'
                      onChange={e => this.handleChange(e)}
                    />
                  </div>
                  <div className='m-login__form-action'>
                    <button
                      id='m_login_signup_submit'
                      className={
                        'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn ' +
                        (this.props.isLoading
                          ? ' m-loader m-loader--right m-loader--light'
                          : '')
                      }
                    >
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    userIsAuthenticated: state.authentication.loggedIn,
    isLoading: state.authentication.submitting,
    errorMessage: state.authentication.errorMessage
  };
}

function mapDispatchToProps (dispatch) {
  return {
    changePassword: password =>
      dispatch({
        type: 'CHANGE_PASSWORD_REQUEST',
        userPayload: {
          password: password
        }
      })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);
